import React from 'react';
import styled, { keyframes } from 'styled-components';
import { IconBase, IconBaseProps } from './IconBase';

const scale = keyframes`
  0%,
  100% {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
`;

const stroke = keyframes`
  100% {
    stroke-dashoffset: 0;
  }
`;

type SuccessCheckMarkProps = IconBaseProps;

const StyledSvg = styled(IconBase)<SuccessCheckMarkProps>`
  animation: ${scale} 0.3s ease-in-out 0.9s both;
  box-shadow: inset 0 0 0 ${(props) => props.theme.palette.green.main};
  stroke: ${(props) =>
    props.color ? props.theme.palette[props.color].main : props.theme.palette.green.main};
  stroke-miterlimit: 10;
  stroke-width: 4;
  overflow: visible;

  circle {
    animation: ${stroke} 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-miterlimit: 10;
    stroke-width: 4;
    fill: none;
  }

  path {
    animation: ${stroke} 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    transform-origin: 50% 50%;
  }
`;

export const SuccessCheckmark: React.FunctionComponent<SuccessCheckMarkProps> = ({ ...props }) => {
  return (
    <StyledSvg {...props} viewBox="0 0 52 52">
      <circle cx="26" cy="26" r="25" />
      <path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
    </StyledSvg>
  );
};
